import { IOrderElement } from '../model/types'

const calculateSum = (array: IOrderElement[] = []): number => {
  return array?.reduce((sum, { price }) => sum + price * 0.01, 0) ?? 0
}

export default calculateSum
